var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockOpenRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5729_3411",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5729_3411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.49998 11.6673H10.5V5.83398H3.49998V11.6673ZM6.99998 9.91732C7.32081 9.91732 7.59547 9.80308 7.82394 9.57461C8.05241 9.34614 8.16665 9.07148 8.16665 8.75065C8.16665 8.42982 8.05241 8.15517 7.82394 7.92669C7.59547 7.69822 7.32081 7.58398 6.99998 7.58398C6.67915 7.58398 6.40449 7.69822 6.17602 7.92669C5.94755 8.15517 5.83331 8.42982 5.83331 8.75065C5.83331 9.07148 5.94755 9.34614 6.17602 9.57461C6.40449 9.80308 6.67915 9.91732 6.99998 9.91732ZM3.49998 12.834C3.17915 12.834 2.90449 12.7197 2.67602 12.4913C2.44755 12.2628 2.33331 11.9882 2.33331 11.6673V5.83398C2.33331 5.51315 2.44755 5.2385 2.67602 5.01003C2.90449 4.78155 3.17915 4.66732 3.49998 4.66732H7.58331V3.50065C7.58331 2.69371 7.86769 2.00586 8.43644 1.43711C9.00519 0.868359 9.69304 0.583984 10.5 0.583984C11.3069 0.583984 11.9948 0.868359 12.5635 1.43711C13.1323 2.00586 13.4166 2.69371 13.4166 3.50065H12.25C12.25 3.01454 12.0798 2.60135 11.7396 2.26107C11.3993 1.92079 10.9861 1.75065 10.5 1.75065C10.0139 1.75065 9.60067 1.92079 9.2604 2.26107C8.92012 2.60135 8.74998 3.01454 8.74998 3.50065V4.66732H10.5C10.8208 4.66732 11.0955 4.78155 11.3239 5.01003C11.5524 5.2385 11.6666 5.51315 11.6666 5.83398V11.6673C11.6666 11.9882 11.5524 12.2628 11.3239 12.4913C11.0955 12.7197 10.8208 12.834 10.5 12.834H3.49998Z",
    fill: "#3A3A3A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpenRight);
export default __webpack_public_path__ + "static/media/lock_open_right.a35a2231c36698a7f173ffbcef030efd.svg";
export { ForwardRef as ReactComponent };